import { render, staticRenderFns } from "./IconComponent.vue?vue&type=template&id=0c1d0630&scoped=true&"
import script from "./IconComponent.vue?vue&type=script&lang=js&"
export * from "./IconComponent.vue?vue&type=script&lang=js&"
import style0 from "./IconComponent.vue?vue&type=style&index=0&id=0c1d0630&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c1d0630",
  null
  
)

export default component.exports